// Route: /materials/sets — LEGACY redirect → /library.
//
// Сущность переименовывалась дважды: «Наборы» → «Коллекции» → «Библиотека»,
// и редирект указывал на промежуточное имя `/collections`, а тот редиректил
// дальше на `/library`. Старая закладка делала ДВА хопа: лишний круг сети и
// две записи в истории, из-за чего «назад» возвращало пользователя на
// редирект, а тот снова уносил его вперёд. Теперь ведём сразу на канон.
// Промежуточный `/collections` остаётся живым отдельно — на него ссылаются и
// веб, и deep-links репетитора.
//
// ПОЧЕМУ SEARCH ПЕРЕКЛАДЫВАЕТСЯ ПОШТУЧНО, А НЕ `{...search}`.
// Схемы двух роутов несовместимы, и прежний код это скрывал кастом `as never`:
//
//   - `tab: "folders"` целевой роут НЕ ЧИТАЕТ ВООБЩЕ (его `validateSearch`
//     знает `filter | q | type | folder | view | demo`). То есть редирект
//     обещал «открыть папки», а приземлял на обычную Библиотеку — молча,
//     потому что `as never` снимал проверку;
//   - `sortBy` в целевой схеме отсутствует;
//   - `view` есть в обеих, но с РАЗНЫМИ значениями: здесь `grid | table`,
//     там `grid | list`. Закладка вида `?view=table` уехала бы в zod-enum,
//     который такого значения не знает.
//
// Поэтому переносим только `q` (единственный совместимый по смыслу и типу) и
// переводим `table → list`. Отдельной «вкладки папок» в Библиотеке нет: рельс
// папок показан всегда, а `folder` по умолчанию уже `__all__`.

import { tolerantSearch } from "@studyhub/shared/utils/tolerant-search";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
	sortBy: z.enum(["updatedAt", "createdAt", "name", "materialsCount"]).optional(),
	q: z.string().optional(),
	view: z.enum(["grid", "table"]).optional(),
});

export const Route = createFileRoute("/materials/sets/")({
	validateSearch: tolerantSearch(searchSchema),
	beforeLoad: ({ search }) => {
		throw redirect({
			to: "/library",
			search: {
				...(search.q ? { q: search.q } : {}),
				...(search.view ? { view: search.view === "table" ? "list" : "grid" } : {}),
			},
			replace: true,
		});
	},
});
